<template>
	<div>
		<img src="../../../public/pic/cooperate/coopeation.png" />
		<br /><br /><br />
		<div style="width: 1000px;text-align: left;" class="center_sun">
			<i class="el-icon-sold-out" style="font-size: 40px;font-weight: bold;color: white;">&nbsp;
				{{ $t('lang.buy1')}}
			</i>
			<hr />
			<p style="font-weight: bold;font-size: 30px;">{{ $t('lang.buy2')}} </p>
			<p>{{ $t('lang.buy3')}}</p>
			<p>{{ $t('lang.buy5')}}</p>
			<p>{{ $t('lang.buy6')}}</p>
			<p v-show="this.$i18n.locale == 'zh'">{{ $t('lang.buy7')}} </p>
			<p>{{ $t('lang.buy8')}}</p>
			<p>{{ $t('lang.buy9')}}</p>
			<p>{{ $t('lang.buy10')}}</p>
			<p v-show="this.$i18n.locale == 'zh'">{{ $t('lang.buy11')}}</p>
			<div v-show="this.$i18n.locale == 'zh'" style="width: 200px;height: 200px; position: relative;top: -300px;left: 600px;z-index: 888;">
				<img src="../../../public/index/erweima.png" />
			</div>
			<div v-show="this.$i18n.locale == 'en'" style="width: 200px;height: 200px; position: relative;top: -200px;left: 600px;z-index: 888;">
				<img src="../../../public/index/erweima1.png" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	head(){
		return {
			title : '商务合作_深圳全智能机器人科技有限公司。Buy Products_Shenzhen All Intelligent Technology Co., Ltd.',
			keywords : '消毒机器人,迎宾机器人，陪护机器人,送餐机器人,硅胶实体娃娃,深圳全智能机器人科技有限公司。Disinfection Robot,Reception Robot,Companion Robot,Delivery Robot,Silicone Dolls,Shenzhen All Intelligent Technology Co., Ltd.',
			description : '全智能科技（AI-Tech）是深圳全智能机器人科技有限公司[Shenzhen All Intelligent Technology Co.，Ltd. ]的简称，沿革于2013年，创建于2016年8月18日。顾名思义，全智能科技（AI-Tech）是以研发、生产、销售人工智能技术服务和产品的国家级高新技术企业。我们利用自主开发的核心技术，以“虚实结合、软硬兼备”的模式，致力于打造实用型的新型人工智能技术和AI科技共享平台。  AI-Tech short for Shenzhen All Intelligent Technology Co.，Ltd. started in 2013 which is a national level high tech company researching, manufacturing, selling AI services and AI products. We leverage self-developed core technologies,combine services with products,software with hardware, dedicating to creat a sharable platform of new pratical AI technology.',
			};
	},
}
</script>

<style scoped>
	img{
		width: 100%;
	}
	
</style>
